<template>
    <b-row>
        <b-col cols="4">
            <div class="d-flex justify-content-center">
                <img :src="image"  width="70" alt="..." class="img-logo img-thumbnail img-fluid" style="display: block;">
            </div>
        </b-col>
        <b-col cols="4">
            <div class="text-center">
                <div>
                    <span class=""><b>{{ company }}</b></span>
                </div>
                <div>
                    <span class="">{{ nit }}</span>
                </div>
                <div>
                    <span class="">{{ address }}</span>
                </div>
            </div>
        </b-col>
        <b-col cols="4">
            <div class="d-flex justify-content-center" style="margin: 30px;">
            <span>No. <b>{{ consecutive }}</b></span>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import apiClient1 from '@/services/axios'

export default {
  name: 'HeaderCompany',
  props: {
    consecutive: Number,
  },
  data() {
    return {
      image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Placeholder_no_text.svg/1200px-Placeholder_no_text.svg.png',
      company: '',
      nit: '',
      address: '',
    }
  },
  watch: {
    consecutive: function(newConsecutive, oldConsecutive) {
      this.consecutive = newConsecutive
    },
  },
  created() {
    // console.log('STORE PRO MAX', this.$store.getters['user/user'].idSchool)
    const idSchool = this.$store.getters['user/user'].idSchool
    // Trae la información del colegio
    apiClient1.get(`schools/${idSchool}`).then((res) => {
      const { data } = res
      let name = ''
      if (data.typePerson === '1') {
        // Persona natural
        ['firstName', 'secondName', 'firstLastName', 'secondLastName'].forEach((k) => {
          if (data[k] !== null) {
            name += ' ' + data[k]
          }
        })
      } else {
        // Persona juridica
        name = data.name
      }
      if (data.logo !== null && data.logo !== '') {
        this.image = data.logo
      }
      this.company = name
      this.nit = data.nit
      this.address = data.address
    }).catch((err) => {
      console.log(err)
    })
  },
}
</script>
